import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import SarasPopup from '../../../../library/container/popup/SarasPopup';
import ItemForecastRow from './ItemForecastRow'

const ItemForecast = (props) => {
    const { formObject, viewData, anchorRef } = props;

    if (!viewData)
        return (null)

    return (
        <SarasPopup anchorRef={anchorRef} open={true}>
        <div className="uiPopupItem">
            <div>
                <span className="uiLbl"><SarasTrans value="Pending Actions" /></span>
            </div>
            <div className="uiFormMini">
                <ul className="uiListTable">
                    {
                        Object.values(viewData).map((row, index) => (
                            <ItemForecastRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                        ))
                    }
                </ul>
            </div >
        </div >
        </SarasPopup>
    )
}

export default withView(ItemForecast, "itemForecast", "")